//include 8
jQuery(function(){
    
    var ratingWrapper = $(".rating-wrapper");
    if(ratingWrapper.length == 0){
        return;
    }

    var privateFunctions = {
        updateHearts(average_rating){
            var itemHearts = $('.item.hearts');
            if(itemHearts.length == 0)
                return;
            var hearts = itemHearts.find("li.heart");
            hearts.removeClass('active').removeClass("half");
            hearts.each(function(){
                var heart = $(this);
                var index = hearts.index(heart);
                if(index < average_rating){
                    heart.addClass("active");
                    if(index + 0.5 > average_rating){
                        heart.addClass("half");
                    } 
                }
            });
        },
        updateTooltip(average_rating){
            var tooltip = $(".rating-wrapper .tooltipstered");
            var content="";
            var von = window.ppt.translate('von','von');
            if(tooltip.length == 0){
                return;
            }
            if(tooltip.hasClass("tooltipstered")){
                try{
                    content = tooltip.tooltipster("content"); //do we even need this?
                }
                catch(e){
                     window.pixelpoint.tooltip.init(tooltip);                    
                }
                setTimeout(function(){
                    content = `${average_rating} ${von} 5`;
                    tooltip.tooltipster("content",content);  
                },100);
            }
            else{
                content = tooltip.attr("title"); //do we even need this?
                content = `${average_rating} ${von} 5`; 
                tooltip.attr("title",content);
            }
        },
        updateNumberOfRatings(rating_count){
            var tooltip = $(".rating-wrapper .tooltipstered");
            if(tooltip.length == 0){
                return;
            }
            var bewertungenTranslate = window.ppt.translate('rating.plural','Bewertungen');
            tooltip.text(`${rating_count} ${bewertungenTranslate}`);
        },
        updatePopup(ratings){
            var ratingCount = [0,0,0,0,0];
            if(!ratings)
                return;
            $.each(ratings,function(i,rating){
                var index = rating.value - 1;
                if(index >= 0 && index < ratingCount.length)
                    ratingCount[index] += 1;
            });
            $(".rating-tooltip .legend .ratings-row").each(function(index){
                if(index < ratingCount.length){
                    $(this).find(".ratings-count").text(ratingCount[index]);
                }
            });
        }
    };

    var ppId = ratingWrapper.data("poi-id");
    var ppType = ratingWrapper.data("poi-type") || "poi";
    if(!ppId){
        return;
    }

    $.ajax({
        url:window.pixelpoint.utilities.getAjaxUrl(`/index.php?action=getRatings&type=1732176051`),
        method:'POST',
        data:{
            pp_id:ppId,
            pp_type:ppType
        },
        success:function(data){
            if(!!data.average_rating){
                privateFunctions.updateHearts(data.average_rating);
                privateFunctions.updateTooltip(data.average_rating);
            }
            if(!!data.rating_count){
                privateFunctions.updateNumberOfRatings(data.rating_count);
            }
            if(!!data.ratings){
                privateFunctions.updatePopup(data.ratings);
            }
        }
    });
});